
export default function SuitableFor() {
  const suitable = [
    'ポイント管理が面倒で、自動で値引きしてほしい方',
    '外食が多く、ポイントを効率よく貯めたい方',
    '空港ラウンジを無料で利用したい方',
    '旅行保険が充実したカードを探している方',
    'サブスクコンテンツを多く利用している方',
    '年5回以上カードを利用する方（年会費無料条件）',
  ];

  const notSuitable = [
    'ポイントをマイルや他社ポイントに交換したい方',
    '学生の方（申込条件外）',
    'カードをほとんど使わない方（年5回未満だと年会費発生）',
    'ポイントの使い道を自分で選びたい方',
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1A1A2E] mb-12 text-center">
          ジャックス Gold Timeが向いている人・向いていない人
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-[#E8F5E9] to-[#C8E6C9] rounded-xl p-6 md:p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-[#4CAF50] rounded-full">
                <i className="ri-check-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-[#2E7D32]">向いている人</h3>
            </div>
            <ul className="space-y-4">
              {suitable.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#4CAF50] text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="text-gray-700 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-gradient-to-br from-[#FFEBEE] to-[#FFCDD2] rounded-xl p-6 md:p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-[#F44336] rounded-full">
                <i className="ri-close-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-[#C62828]">向いていない人</h3>
            </div>
            <ul className="space-y-4">
              {notSuitable.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-close-circle-fill text-[#F44336] text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="text-gray-700 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
